import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import taskKeys from './keyFactory';

const GetTask = graphql(`
  query Task($taskId: ID!) {
    task(id: $taskId) {
      __typename
      publicId
      ... on IEntity {
        id
      }
      createdBy {
        id
      }
      name
      completedAt
      deadline
      notes
      completionStatus
      assignedTo {
        __typename
        ... on User {
          publicId
          firstName
          lastName
          email
          colour
          avatarUrl
        }
        ... on Team {
          id
          name
        }
      }
      project {
        id
        publicId
        reference
      }
      events {
        id
        name
      }
      ... on LegacyFormTask {
        documentId
        formRevisions {
          id
        }
        formTemplate {
          id
        }
      }
      ... on FormTask {
        documentId
        formRevisions {
          id
        }
        formTemplate {
          id
        }
      }
      ... on ChecklistTask {
        checklistItems {
          id
          publicId
          name
        }
      }
      ... on MaterialsListTask {
        materialsListMaterials {
          quantity
          material {
            id
            name
            description
          }
        }
      }
      ... on CustomFieldsTask {
        customFields {
          field {
            identifier
            label
            schema
          }
          value
        }
      }
    }
  }
`);

const useGetTask = (id?: number) => {
  const { data, ...rest } = useQuery({
    enabled: !!id,
    queryKey: taskKeys.task(id!),
    queryFn: () => {
      return gqlClient.request(GetTask, {
        taskId: `${id}`,
      });
    },
  });

  const task = data?.task;

  return { task: task, data, ...rest };
};

export default useGetTask;
